import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import bannerImg from "../images/management/employeeManagement/employeeManagement.png"
import mobbannerImg from "../images/management/employeeManagement/mobEmployeeManagement.png"
import icon1 from "../images/management/employeeManagement/1.png"
import icon2 from "../images/management/employeeManagement/2.png"
import icon3 from "../images/management/employeeManagement/3.png"
import icon4 from "../images/management/employeeManagement/4.png"
import icon5 from "../images/management/employeeManagement/5.png"
import content1 from "../images/management/enterprise/ent-content.png"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import CustomProducts from "../components/cards/custom-products/index"
import product1 from "../images/emp.png"
import NewProducts from "../components/cards/newproducts/index"
import SubPageBanner from "../components/subpagebanner/SubPageBanner"
import { navigate } from "gatsby"
import ListContent from "../components/cards/listContent"


const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem 6rem',
  },
  img: {
    height: '400px',
    width: '1200px',
  },
}))

const AiAnalytics = ({ data, location: { pathname } }) => {

  const classes = useStyles()
  const theme = useTheme()

  const sectionData = {
    title: "People & AI Analytics",
    content: `Wersel Workdesk keeps track of the growth and performance of your workforce both People & AI, no matter where they are in the world, Wersel's WorkDesk centralizes all business data in one location with Blockchain enabled Data Security & Privacy.`,
    buttonText: "Book Demo",
    buttonClick: () => navigate("/contact"),
    reasons: [
      {
          title: 'Performance Management',
          description: 'It’s simple and efficient to manage employee performance using Wersel. The platform allows businesses to run performance reviews on a frequent basis, improving employee efficiency. Moreover, Wersel also facilitates public celebration of employee’s achievements.',
          icon: icon1
      },
      {
          title: 'Employee Engagement Analysis',
          description: 'Wersel offers features such as eNPS, Pulse and surveys, which can be used to identify employee opinions. Employees want their voices to be heard. The platform ensures that it isn’t just heard but properly analysed to retain top talent and maintain business growth.',
          icon: icon2
      },
      {
          title: 'Achieve Talent Acceleration',
          description: "Another wonderful thing about having Wersel is the ability to transform talent management into talent acceleration. Using the features such as Individual Development Plans, Career Tracks, etc., businesses can help employees achieve immense career growth.",
          icon: icon3
      },
      {
        title: 'Simplified Compensation Review',
        description: "Wersel brings a new and more efficient way of distributing compensations & appraisals. The platform connects employee performance with compensation. In other words, data-driven decisions are made based on performance analyses. This helps in driving employee retention and enhanced employee engagement.",
        icon: icon4
      },
      {
        title: 'HR Analytics',
        description: "The HRs can make data-driven decisions using Wersel. The features such as AI-powered sentiment analysis, unified dashboards, and continuous analytics helps HR drive innovation and impact. The platform offers a connection between employee insights and decision-making.",
        icon: icon5
      },
  ],
  }
   const { reasons, title, content, buttonClick, buttonText } = sectionData

  return (
    <Layout withBrand slidePosition={0}>
      <SEO
        description="Deliver a phenomenal experience to your targeted shoppers and ensure that your brand maintains its credibility in the market with our brand analytics platform"
        keywords="brand analytics, brand analytics platform, brand analytics software, wersel, wersel brand analytics, wersel data hub"
        title="Wersel - AI Enabled People Analytics & Insights Software"
        url="www.wersel.io/"
      />
      <div style={{ paddingTop: '3px' }}>
        <SubPageBanner webbannerimg={bannerImg}  mobbannerimg={mobbannerImg} bannerHeading={title} bannerContent={content} buttonClick={buttonClick} buttonText={buttonText} />
      </div>
      <ListContent reasons={reasons} />
    </Layout>
  )
}


export default AiAnalytics
